"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCreditCardVoidFromJsonToXml = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const enums_1 = require("../../enums");
const convertCreditCardVoidFromJsonToXml = (params) => {
    const builder = new fast_xml_parser_1.XMLBuilder({ ignoreAttributes: false });
    const input = {
        CreditCardVoid: {
            Credentials: params.credentials,
            Application: params.application,
            Transaction: {
                MarketCode: enums_1.MarketCode.ECOMMERCE,
                ...params.transaction,
            },
            Terminal: {
                CardholderPresentCode: enums_1.CardholderPresentCode.ECOMMERCE,
                CardInputCode: enums_1.CardInputCode.MANUAL_KEYED,
                CardPresentCode: enums_1.CardPresentCode.NOT_PRESENT,
                CVVPresenceCode: enums_1.CVVPresenceCode.PROVIDED,
                TerminalID: 0,
                MotoECICode: enums_1.MotoECICode.NON_AUTHENTICATED_SECURE_ECOMMERCE_TRANSACTION,
                TerminalCapabilityCode: enums_1.TerminalCapabilityCode.KEY_ENTERED,
                TerminalEnvironmentCode: enums_1.TerminalEnvironmentCode.ECOMMERCE,
                TerminalType: enums_1.TerminalType.ECOMMERCE,
            },
            '@_xmlns': 'https://transaction.elementexpress.com',
        },
    };
    const xml = builder.build(input);
    return xml;
};
exports.convertCreditCardVoidFromJsonToXml = convertCreditCardVoidFromJsonToXml;
//# sourceMappingURL=ConvertCreditCardVoidFromJsonToXml.js.map